import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'filter', pure: false })
// tslint:disable-next-line:class-name
export class filter implements PipeTransform {
  // tslint:disable-next-line:no-shadowed-variable
  transform(items: any[], filter: any[], IsStrict: boolean): any[] {
    if (typeof (IsStrict) === 'undefined') {
      IsStrict = false;
    }
    try {
      if (!items) { return []; }
      let isValueExist: boolean = false;
      const isObject: boolean = (typeof (filter) === 'object' && Object.keys(filter).length > 0);

      if (isObject) {
        for (const key in filter) {
          if (typeof (filter[key]) !== 'undefined') {
            isValueExist = true;
            break;
          }
        }
      }
      else {
        if (typeof (filter) !== 'undefined' && filter.toString().trim() !== '') {
          isValueExist = true;
        }
      }
      if (isValueExist) {
        return items.filter(item => {
          let keys: string[];
          let isFound: boolean = false;
          if (isObject) { // key filter
            for (const key in filter) {
              if (IsStrict) {
                if (item[key] !== null && typeof (filter[key]) !== 'undefined') {
                  if (item[key].toString().toLowerCase() === (filter[key].toString().toLowerCase()) || filter[key].toString().trim() === '') {
                    isFound = true;
                  }
                  break;
                }
              }
              else {
                if (item[key] !== null && typeof (filter[key]) !== 'undefined') {
                  if (item[key].toString().toLowerCase().indexOf(filter[key].toString().toLowerCase()) !== -1 || filter[key].toString().trim() === '') {
                    isFound = true;
                  }
                  break;
                }
              }
            }
            keys = Object.keys(filter);
          }
          else { // string filter
            for (const key in item) {
              if (item[key] !== null && item[key].toString().toLowerCase().indexOf(filter.toString().toLocaleLowerCase()) !== -1) {
                isFound = true;
                break;
              }
            }
            keys = Object.keys(item);
          }
          return isFound;
        }
        );
      }
      else {
        return items;
      }
    }
    catch (e) {
      return items;
    }
  }
}


@Pipe({ name: 'reverse' })
export class ReversePipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
  }
}


@Pipe({ name: 'timegreeting' })
export class TimeGreetingPipe implements PipeTransform {
  transform(value: string) {
    const inputDate: Date = new Date(value);
    if (String(inputDate) !== 'Invalid Date') {
      const currentDate: Date = new Date((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear());
      const daysList = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

      const milliSecoundOfDay = 1000 * 60 * 60 * 24;
      const stringDateDiffInDay = Math.round((currentDate.getTime() - inputDate.getTime()) / milliSecoundOfDay).toFixed(0);
      if (!isNaN(Number(stringDateDiffInDay))) {
        const intDateDiffInDay = Number(stringDateDiffInDay);
        if (intDateDiffInDay === 0) {
          return 'TODAY';
        } else if (intDateDiffInDay === 1) {
          return 'YESTERDAY';
        } else if (intDateDiffInDay <= 6 && intDateDiffInDay >= 2) {
          return daysList[inputDate.getDay()];
        } else {
          return value;
        }
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
}


@Pipe({ name: 'stringFilterBy' })
export class StringFilterByPipe implements PipeTransform {
  transform(arr: any[], searchText: string, fieldName?: string): any[] {
    if (!arr) { return []; }
    if (!searchText) { return arr; }
    searchText = searchText.toLowerCase();
    return arr.filter((it: any) => {
      if (typeof it === 'string') {
        return it.toLowerCase().includes(searchText);
      } else if (typeof it === 'number') {
        return it.toString().toLowerCase().includes(searchText);
      } else {
        return it[fieldName] ? it[fieldName].toLowerCase().includes(searchText) : false;
      }
    });
  }
}


@Pipe({ name: 'utcTolocal' })
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string, format: string): any {
    if (value) {
      if (format) {
        value = moment.utc(value).local().format(format);
      } else {
        value = moment.utc(value).local().format('L');
      }
      return value;
    } else {
      return '';
    }
  }
}

